import findOneCourse from 'Api/Request/Course/findOneCourse';

/**
 * Obtiene la información de un curso específico.
 * @params {string} courseId ID del curso a consultar.
 * @returns {import('Api/Request/Course/findOneCourse').CourseData} Información relevante del curso.
 */
const readOne = async courseId => {
  const course = await findOneCourse(courseId);
  return course;
};

const CourseDetailsApi = {
  readOne,
};

export default CourseDetailsApi;
